import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Typography,
  Button,
  Spinner,
} from '@material-tailwind/react';

function RecommendationsTextEditor({ content, originalContent, onSave, onReset, isSaving }) {
  const [text, setText] = useState('');
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    setText(content?.text ?? '');
    setHasChanges(false);
  }, [content?.text]);

  useEffect(() => {
    setHasChanges(text !== (content?.text ?? ''));
  }, [text, content?.text]);

  const handleSave = () => {
    if (onSave) onSave({ text });
  };

  const handleReset = () => {
    setText(originalContent?.text ?? content?.text ?? '');
    setHasChanges(false);
    if (onReset) onReset();
  };

  return (
    <Card className="h-full flex flex-col">
      <CardBody className="flex-1 flex flex-col p-4 overflow-auto">
        <Typography variant="h6" color="blue-gray" className="mb-3">
          Recommendations
        </Typography>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          className={`flex-1 w-full p-3 border rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent min-h-[200px] ${
            hasChanges ? 'border-amber-300 bg-amber-50' : 'border-gray-300'
          }`}
          placeholder="AI-generated recommendations..."
        />
        <div className="flex justify-end gap-2 mt-3">
          <Button
            variant="outlined"
            size="sm"
            onClick={handleReset}
            disabled={!hasChanges || isSaving}
          >
            Reset
          </Button>
          <Button
            size="sm"
            onClick={handleSave}
            disabled={!hasChanges || isSaving}
          >
            {isSaving ? <><Spinner className="h-4 w-4 mr-1" />Saving...</> : 'Save'}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
}

export default RecommendationsTextEditor;
